import { motion } from "framer-motion";

const LOGO = "https://customer-assets-v7afamib.emergentagent.net/job_7ad6febd-76b7-4ae8-88ea-7738fdc731d1/artifacts/zi1d15ox_image.png";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el && window.__lenis) window.__lenis.scrollTo(el, { offset: -20 });
  else el?.scrollIntoView({ behavior: "smooth" });
};

export const NomadLogo = ({ size = 58 }) => (
  <div className="flex items-center gap-3" data-testid="nomad-logo">
    <img
      src={LOGO}
      alt="Nomad Capital"
      style={{ width: size, height: size }}
      className="rounded-full"
    />
    <span className="font-display tracking-[0.28em] text-base font-500 text-[#f2f0eb]">
      NOMAD<span className="hidden sm:inline text-[#8a8a8a] ml-2 tracking-[0.34em] text-sm">CAPITAL</span>
    </span>
  </div>
);

const Nav = () => (
  <motion.header
    initial={{ y: -60, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.8, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
    className="fixed top-0 left-0 right-0 z-50 border-b border-white/[0.06] bg-black/60 backdrop-blur-xl"
    data-testid="site-nav"
  >
    <div className="max-w-screen-2xl mx-auto px-6 md:px-12 h-[72px] flex items-center justify-between">
      <button onClick={() => scrollTo("hero")} data-testid="nav-logo-button" aria-label="Home">
        <NomadLogo />
      </button>
      <nav className="hidden md:flex items-center gap-10 font-mono-tech text-[11px] tracking-[0.2em] uppercase text-[#8a8a8a]">
        <button onClick={() => scrollTo("who-we-are")} className="hover:text-[#f2f0eb] transition-colors duration-300" data-testid="nav-firm-link">Firm</button>
        <button onClick={() => scrollTo("thesis")} className="hover:text-[#f2f0eb] transition-colors duration-300" data-testid="nav-thesis-link">Thesis</button>
      </nav>
      <button
        onClick={() => scrollTo("contact")}
        className="font-mono-tech text-[11px] tracking-[0.2em] uppercase whitespace-nowrap px-4 py-2 sm:px-5 sm:py-2.5 bg-[#e65c00] text-black font-medium hover:bg-[#ff7a1a] transition-colors duration-300"
        data-testid="nav-contact-button"
      >
        <span className="sm:hidden">Contact</span>
        <span className="hidden sm:inline">Get in Touch</span>
      </button>
    </div>
  </motion.header>
);

export default Nav;
